import { createContext } from "react";

// Export all contexts
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const ColorModeContext = createContext({ toggleColorMode: () => {} });
// Context for Form data control
export const FormDataControlContext = createContext("formDataControl");
